import { reduxField } from '../../../reduxHelpers'
const { reducer, actions, saga } = reduxField.HR.BANK_DETAILS()
export { reducer, actions, saga }
